import React from 'react';
import {
  Nav,
  Hero,
  Gallery,
  Services,
  About,
  Differentials,
  Testimonials,
  Contact,
  CTA,
  Footer,
  WhatsAppFloat
} from '../../components/sections';

const Home = () => {
  return (
    <div className="min-h-screen bg-goshine-dark overflow-x-hidden">
      <Nav />
      <Hero />
      <Gallery />
      <Services />
      <About />
      <Differentials />
      <Testimonials />
      <Contact />
      <CTA />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default Home;
